<template>
	<div class="d-uploader" :class="active_variant" :data-active="active" @dragenter.prevent="setActive" @dragover.prevent="setActive"
		@dragleave.prevent="setInactive" @drop.prevent="onDrop">
		<slot :dropZoneActive="active" :dropZoneVariant="active_variant"></slot>
	</div>
</template>

<script setup>

import { ref, onMounted, onUnmounted, defineProps, defineEmits, computed } from 'vue'
const emit = defineEmits(['files-dropped'])

const props = defineProps({
	mimetypes: { type: Array, default: null }
})

let all_valid = ref(true);
let all_error = ref(false);

let active = ref(false)
let inActiveTimeout = null

const active_variant =  computed(() => {
	var v = "success";
	if(all_error.value)
		v = "danger";
	else if(!all_valid.value)
		v = "warning";
	return v;
})

// setActive and setInactive use timeouts, so that when you drag an item over a child element,
// the dragleave event that is fired won't cause a flicker. A few ms should be plenty of
// time to wait for the next dragenter event to clear the timeout and set it back to active.
function setActive(e) {
	active.value = true
	clearTimeout(inActiveTimeout)
	CheckValidType(e);
}
function setInactive() {
	inActiveTimeout = setTimeout(() => {
		active.value = false
	}, 50)
}

function CheckValidType(e) {	
	var has_invalid_file = false;
	all_valid.value = true;
	all_error.value = false;
	var types = props.mimetypes;
	if (types == null || types.length <= 0)
		return; // all valid	
	if (e.dataTransfer?.items) {

		var error_count = 0;
		var total_items = 0;
		for (var i = 0; i < e.dataTransfer.items.length; i++) {
			var file_valid = false;
			total_items++;
			var info = e.dataTransfer.items[i];
			if (info.kind != "file") {
				file_valid = false;
				has_invalid_file = true;
			}
			for (var j = 0; j < types.length; j++) {
				if (info.type.includes(types[j]))
					file_valid = true;				
			}
			if(!file_valid){
				error_count++;
				has_invalid_file = true;
			}
		}
		
		if (has_invalid_file) {
			all_valid.value = false;
		}
		if (error_count == total_items)
			all_error.value = true;
	}
}

function onDrop(e) {
	setInactive()
	emit('files-dropped', [...e.dataTransfer.files])
}

function preventDefaults(e) {
	e.preventDefault()
}

const events = ['dragenter', 'dragover', 'dragleave', 'drop']

onMounted(() => {
	events.forEach((eventName) => {
		document.body.addEventListener(eventName, preventDefaults)
	})
})

onUnmounted(() => {
	events.forEach((eventName) => {
		document.body.removeEventListener(eventName, preventDefaults)
	})
})
</script>